import { useMutation } from '@tanstack/react-query';
import { ReportEmailsApiV2 } from 'Data/ReportEmails.api.v2';
import {
  IReportEmailSettings,
  IRequestReportEmailSettings,
} from 'Data/interfaces/Preferences/IReport';
import { REPORT_EMAILS_QUERY_KEY } from 'Data/keys/QueryKeys';
import { queryClient } from 'Context/QueryClientContext';

export const useQueryCreateReportEmail = () => {
  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (variables: IRequestReportEmailSettings) => {
      return ReportEmailsApiV2.createReportEmails(variables);
    },
    onMutate: async (variables) => {
      const previousReportEmails = queryClient.getQueryData<IReportEmailSettings>(
        [REPORT_EMAILS_QUERY_KEY],
      );
      queryClient.setQueryData<IReportEmailSettings>(
        [REPORT_EMAILS_QUERY_KEY],
        () => ({
          ReceiveFileReportEmail: variables.receiveFileReportEmail,
          FileReportPeriodicity: variables.fileReportPeriodicity,
          ReceiveTopicReportEmail: variables.receiveTopicReportEmail,
          TopicReportPeriodicity: variables.topicReportPeriodicity,
          ReceivePlottReportEmail: variables.receivePlottReportEmail,
          PlottReportPeriodicity: variables.plottReportPeriodicity,
        }),
      );
      return { previousReportEmails };
    },
    onError: async (_error, _variables, context) => {
      await queryClient.cancelQueries({ queryKey: [REPORT_EMAILS_QUERY_KEY] });
      queryClient.setQueryData(
        [REPORT_EMAILS_QUERY_KEY],
        context?.previousReportEmails,
      );
    },
  });

  return {
    createReportEmail: mutate,
    createReportEmailAsync: mutateAsync,
    isLoading: isPending,
  };
};
